import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import CardHeader from '@material-ui/core/CardHeader';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';
import ordinal from 'ordinal';
import { shallowEqual } from 'app-source/utils/shallowEqual';

const styles = () => ({
  header: {
    paddingBottom: [0, '!important'],
  },
  title: {
    fontWeight: 800,
  },
  subheader: {
    order: -1,
    textTransform: 'uppercase',
    fontSize: '0.7rem',
  },
  headerContent: {
    display: 'flex',
    flexDirection: 'column',
  },
});

class TriviaRankingHeaderComponent extends Component {
  static propTypes = {
    classes: PropTypes.objectOf(PropTypes.string).isRequired,
    answer: PropTypes.shape({
      earnedPoints: PropTypes.number.isRequired,
    }).isRequired,
    userRanking: PropTypes.shape({
      position: PropTypes.number.isRequired,
    }).isRequired,
  };

  shouldComponentUpdate(nextProps, nextState) {
    return !shallowEqual(this, nextProps, nextState, {
      propsSelectOptions: { omit: ['classes'] },
    });
  }

  render() {
    const { classes, answer, userRanking } = this.props;

    return (
      <Fragment>
        <CardHeader
          title={
            <Fragment>
              <Typography className={classes.title} variant="title">
                You earned {answer.earnedPoints} points
              </Typography>
              <Typography variant="subheading">
                You`re now up to {ordinal(userRanking.position)} place.
              </Typography>
            </Fragment>
          }
          avatar={<Avatar>D</Avatar>}
          subheader={<Typography variant="subheading">Points</Typography>}
          className={classes.header}
          classes={{
            content: classes.headerContent,
            subheader: classes.subheader,
          }}
        />
      </Fragment>
    );
  }
}

export const TriviaRankingHeader = withStyles(styles)(TriviaRankingHeaderComponent);
